import axios from 'axios';
import {ref, onMounted} from 'vue';

import {URLS} from '../config';

export function useGetStatistics() {
  const statistics = ref([]);
  const statisticsLoading = ref(false);

  const getStatistics = async () => {
    statisticsLoading.value = true;

    try {
      const response = await axios.get(URLS.GET_STATISTICS);
      statistics.value = response.data.statistics;
    } catch (error) {
      console.error(error);
    } finally {
      statisticsLoading.value = false;
    }
  };

  onMounted(() => {
    getStatistics();
  });

  return {
    statistics,
    statisticsLoading,
  };
}
